import { css } from "@emotion/core";
import {
  color,
  fontSizes,
  fontTypes,
  fontWeight,
} from "../../constants/commons";
export const professionalDetailsStyle = css`
  .result-container-style {
    width: 100%;
    .info-box {
      justify-content: flex-start;
      align-items: center;
    }
    .info-box-data {
      width: 100%;
      .title {
        flex-direction: row;
        justify-content: space-between;
      }
    }
  }

  .experience-style {
    color: ${color.blue};
    font-family: ${fontTypes.bodyFont};
    font-size: ${fontSizes.xs};
    font-weight: ${fontWeight.medium};
    margin: -2em 0 0 0;
  }

  .sub-heading-dropdown {
    font-size: ${fontSizes.xs};
  }

  .info-container {
    width: 99%;
  }

  .option-field-margin-class {
    margin: 1.5em 0 2em 0;
  }
`;
